import React from 'react';
import SkeletonLib, { SkeletonTheme } from 'react-loading-skeleton';
import type { AtsSkeletonProps } from './types';

export const AtsSkeleton: React.FC<AtsSkeletonProps> = ({ height, width, ...props }) => (
  <SkeletonTheme color="#F7F7F8" highlightColor="#F9FAFA">
    <SkeletonLib height={height} width={width} {...props} />
  </SkeletonTheme>
);
